module.exports = __webpack_public_path__ + "static/img/featrue.6bf2435d.png";